import { render, staticRenderFns } from "./Terminos.vue?vue&type=template&id=df59dbc0&scoped=true"
import script from "./Terminos.vue?vue&type=script&lang=js"
export * from "./Terminos.vue?vue&type=script&lang=js"
import style0 from "./Terminos.vue?vue&type=style&index=0&id=df59dbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df59dbc0",
  null
  
)

export default component.exports